// @ts-nocheck
import { NgClass } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import { EntityFieldsComponent } from '../../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { DatePickerCondensedComponent } from '../date-picker-condensed/date-picker-condensed.component';
import { DateTimePickerCondensedComponent } from '../date-time-picker-condensed/date-time-picker-condensed.component';
import { InputHiddenComponent } from '../input-hidden/input-hidden.component';
import { InputTextCondensedComponent } from '../input-text-condensed/input-text-condensed.component';

@Component({
  selector: 'lbca-additional-values-condensed',
  templateUrl: './additional-values-condensed.component.html',
  imports: [
    NgClass,
    InputHiddenComponent,
    InputTextCondensedComponent,
    forwardRef(() => EntityFieldsComponent),
    DatePickerCondensedComponent,
    DateTimePickerCondensedComponent,
  ],
})
export class AdditionalValuesCondensedComponent {
  public fields: any;
  public isDisabled: any;
  public data: any = {};

  @Input('field') set fieldList(fields: any) {
    this.fields = fields;
  }

  @Input() set disabled(item: any) {
    this.isDisabled = item;
  }

  @Input() set value(value: any) {
    const val = value.length ? value : [value];
    this.data = val[0];
  }

  public cardInfo: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  constructor() {}
}
